import { WEBSITE_URL } from "./constants";

/**
 * Build the public-facing booking URL for a user/event-type.
 *
 * Returns an absolute URL from NEXT_PUBLIC_WEBSITE_URL rather than a
 * relative path — useful anywhere an absolute link is needed regardless
 * of rendering context (emails, ICS descriptions, external shares).
 */
export function getPublicBookingUrl(username: string, slug: string, query?: Record<string, string | string[] | undefined>): string {
  const url = new URL(`/${username}/${slug}`, WEBSITE_URL);

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || key === "user") return;
      if (Array.isArray(value)) {
        value.forEach((v) => v !== undefined && url.searchParams.append(key, v));
      } else {
        url.searchParams.append(key, value);
      }
    });
  }

  return url.toString();
}

/**
 * Build the public-facing profile URL for a user.
 */
export function getPublicProfileUrl(username: string): string {
  return new URL(`/${username}`, WEBSITE_URL).toString();
}
